import type { FaireProductEntity } from "../../entity_types/product";

export const p_wbb69rr7t6: FaireProductEntity = {
  token: "p_wbb69rr7t6",
  type: "product",
  name: "Rise and Shine Vase , Orange Juice",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/a68844f3b89a9f1b6e93e2398aeea9b5ad38715a14ace90705838c67a5e93087.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd3bd5102399b7dd33f12688ed3faaddd010e3fe527b3e599068b6feda62ba21.jpeg",
    "https://cdn.faire.com/fastly/7525671deabf58937ffe075978e6eaf79e2e07c52f9f77b6ffdc4aeed184d067.jpeg",
    "https://cdn.faire.com/fastly/1cea1f44b1c8bf829fc75ebaf643d28c731856d7ad2c7dd00458273b5a5003f9.jpeg",
    "https://cdn.faire.com/fastly/d2e72fe580ecee6328ec73fd98fa277b08c67cb041f6f8d418015fa1e59d8e59.jpeg",
    "https://cdn.faire.com/fastly/004782d85bd88cd981947abd5928ffa0695b763e5ebf70837d623d49d1110be9.jpeg",
    "https://cdn.faire.com/fastly/c1476a39227013712eced6aa49f7830b8511c0687e96efb50ec1453f69b0cce5.jpeg",
    "https://cdn.faire.com/fastly/77f8b32643e7ca82487c8d856c2c5216fc3f589c292134d98e43e1b741ca5c91.jpeg"
  ],
  priceDollars: 14,
  description: "A little-known secret? Flowers love orange juice. Well… they actually just love this ceramic vase that looks like an orange juice carton. With plenty of room for water and a retro design on every side, this piece is as fresh and fun as it sounds. Perfect for brightening up a kitchen, windowsill, or bedside table — no pulp required.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n\n• Made of high-quality ceramic\n• Orange juice carton–inspired design with retro artwork\n• Watertight interior perfect for fresh flowers or greenery\n• Adds a playful, colorful touch to any space\n• Designed in Bando’s signature cheerful, nostalgic style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫:\n\n• Gift shops and home décor boutiques\n• Lifestyle retailers and kitchenware stores\n• Floral studios and event stylists\n• Wholesale buyers seeking unique, statement ceramics",
  tags: [],
  msrpDollars: 28.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:14.204Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
